import { Component, OnInit } from "@angular/core";
import { MainService } from "../../app.service";
import { Roles } from "../../enums/roles";

@Component({
  selector: "app-sonar-extractor",
  templateUrl: "./sonar-extractor.component.html",
  styleUrls: ["./sonar-extractor.component.css"],
})
export class SonarExtractorComponent implements OnInit {
  tabLoaded = {
    dashboard: false,
    runs: false,
    issues: false,
    reports: false,
    releases: false,
    projects: false,
    datastudio: false,
  };

  constructor(public mainservice: MainService) {}

  /** Acesso total: superuser e sonaradmin */
  get isFullAccess(): boolean {
    const roles = this.mainservice.sRoles;
    return roles.includes(Roles.SUPERUSER) || roles.includes(Roles.SONARADMIN);
  }

  ngOnInit(): void {
    this.mainservice.validSession();

    if (this.isFullAccess) {
      this.tabLoaded.dashboard = true;
    } else {
      this.tabLoaded.issues = true;
    }
  }

  onTabClick(tab: keyof SonarExtractorComponent['tabLoaded']): void {
    this.tabLoaded[tab] = true;
  }
}
